'use client';
import { useState } from 'react';
import { LuCoins } from 'react-icons/lu';
import { useTranslations } from 'next-intl';
import { validatePrice } from '@/utils/category';
import { IoIosArrowForward } from 'react-icons/io';
import { handlePriceByComma } from '@/helpers/common';
import RabehLoyaltyModal from '@/components/ui/modals/rabeh-loyalty-modal';
import { usePathname } from '@/i18n/navigation';
import { signIn } from 'next-auth/react';
import { event_button_click } from '@/utils/gtm';

const ProductPoints = ({ price: priceWithTax, rabeh_earn_points, session }) => {
  const t = useTranslations('product');
  const pathname = usePathname();
  const price = validatePrice(priceWithTax);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isEnrolled = session?.user?.is_rabah_customer === '1';

  return (
    <>
      <div
        className={`flex items-center gap-2 rounded-lg ${isEnrolled ? 'bg-blue-50' : 'bg-amber-50'} p-3`}
      >
        <LuCoins
          size={18}
          className={`${isEnrolled ? 'text-blue-600' : 'text-amber-600'}`}
        />

        <div className='w-full'>
          {isEnrolled ? (
            <p className='text-sm font-medium'>
              {t('you_will_earn')}{' '}
              <span className='font-bold'>
                {rabeh_earn_points
                  ? rabeh_earn_points
                  : handlePriceByComma(price?.originalPrice)}
              </span>{' '}
              {t('points on this item')}
            </p>
          ) : (
            <div className='flex items-center justify-between'>
              <p className='text-sm font-medium'>
                {t('Earn')}{' '}
                <span className='font-bold'>
                  {rabeh_earn_points
                    ? rabeh_earn_points
                    : handlePriceByComma(price?.originalPrice)}
                </span>{' '}
                {t('Join our loyalty program')}
              </p>

              <button
                onClick={() => {
                  event_button_click({
                    button_name: 'Join Now',
                    button_destination: session?.user
                      ? 'open_loyalty_modal'
                      : '/login',
                    button_location: 'pdp',
                  });
                  session?.user
                    ? setIsModalOpen(true)
                    : signIn(undefined, { callbackUrl: `/${pathname}` });
                }}
                className='flex items-center justify-center rounded-md bg-amber-500 px-3 py-1 text-xs font-medium text-white transition-colors hover:bg-amber-600'
              >
                {t('Join now')}
                <IoIosArrowForward size={14} className='ms-1 rtl:rotate-180' />
              </button>
            </div>
          )}
        </div>
      </div>
      {isModalOpen && (
        <RabehLoyaltyModal {...{ isModalOpen, setIsModalOpen }} />
      )}
    </>
  );
};

export default ProductPoints;
